import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty';
import { useEffect } from 'react';

type HookProps = {
  placeholder: string;
};

const PlaceholderPlugin: React.FC<HookProps> = ({ placeholder }) => {
  const [editor] = useLexicalComposerContext();
  const isEmpty = useLexicalIsTextContentEmpty(editor);

  /* Set the placeholder on root. */
  useEffect(() => {
    const rootElement = editor.getRootElement() as HTMLElement;
    if (rootElement) {
      if (isEmpty && placeholder) {
        rootElement.setAttribute('placeholder', placeholder);
      } else {
        rootElement.removeAttribute('placeholder');
      }
    }
  }, [editor, isEmpty]); // eslint-disable-line

  return null;
};

export default PlaceholderPlugin;
